<div class="page-content" *ngIf="currentUser.role.seeLogCases">
  <div class="header">
    <div class="back-content">
      <mat-icon (click)="back()">arrow_back_ios</mat-icon>
    </div>
    <div class="title">
      <h3>Log control de casos</h3>
    </div>
    <div class="isLoading">
      <div *ngIf="isLoading" style="text-align: center">Cargando...</div>
      <div class="loading" *ngIf="isLoading">
        <mat-spinner diameter="18"></mat-spinner>
      </div>
    </div>
    <div class="divCsv">
      <button (click)="exportToCsv()" mat-button class="btnCsv primary-btn">
        Exportar CSV
      </button>
    </div>
    <!-- <div class="divParentSearch">
      <div class="search-content">
        <div class="searchbar">
          <button class="search_icon" (click)="filterData()">
            <i class="fas fa-search"></i>
          </button>
          <input
            class="search_input"
            [(ngModel)]="search"
            (keyup)="filterData()"
            type="text"
            placeholder="Buscar casos"
          />
          <mat-icon (click)="searchTouch = !searchTouch" class="tune"
            >tune</mat-icon
          >
        </div>
    
        <filter-cases-ras [users]="users" [open]="searchTouch"></filter-cases-ras>
      </div>
    </div> -->
    <div class="divParentSearch">
      <div class="search-content">
        <div class="divFilter">
          <button
            (click)="searchTouch = !searchTouch"
            mat-button
            class="btnCsv primary-btn"
          >
            <mat-icon class="tune">tune</mat-icon>
            Filtros <span class="countFilters">{{ count }}</span>
          </button>
        </div>
        <div class="search-content">
          <div class="searchbar">
            <input
              class="search_input"
              type="text"
              placeholder="Filtrar..."
              (keyup)="filter($event)"
            />
            <button class="search_icon">
              <i class="fas fa-search"></i>
            </button>
          </div>

          <filter-log-cases
            (count)="setCount($event)"
            [open]="searchTouch"
          ></filter-log-cases>
        </div>
      </div>
    </div>

    <!-- Revisar esto colocar el componenete -->
  </div>
  <div>
    <div class="table-content mat-elevation-z8">
      <div class="table-scroll">
        <!-- Mat table -->
        <table mat-table [dataSource]="dataSourceCaseLogs" matTableFilter>
          <ng-container matColumnDef="ip">
            <th mat-header-cell *matHeaderCellDef>Ip</th>
            <td mat-cell *matCellDef="let element">
              {{ element.ip }}
            </td>
          </ng-container>
          <ng-container matColumnDef="user_id">
            <th mat-header-cell *matHeaderCellDef>id usuario</th>
            <td mat-cell *matCellDef="let element">
              {{ element.user_id }}
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Rol</th>
            <td mat-cell *matCellDef="let element">{{ element.role }}</td>
          </ng-container>
          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef>Unidad</th>
            <td mat-cell *matCellDef="let element">
              {{ element.unit }}
            </td>
          </ng-container>
          <ng-container matColumnDef="case_type">
            <th mat-header-cell *matHeaderCellDef>Tipo caso</th>
            <td mat-cell *matCellDef="let element">
              {{ element.case_type }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">
              {{ element.status }}
            </td>
          </ng-container>
          <ng-container matColumnDef="gai">
            <th mat-header-cell *matHeaderCellDef>Gai</th>
            <td mat-cell *matCellDef="let element">
              {{ element.gai }}
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Acción</th>
            <td mat-cell *matCellDef="let element">
              {{ element.action }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let element">
              {{ element.date | date : "d/M/yy, h:mm:ss a" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCaseLogs"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsCaseLogs"
          ></tr>
        </table>
      </div>
      <mat-paginator
        #caseLogsPaginator
        [pageSizeOptions]="[10, 25, 100]"
        aria-label="Select page of roles"
      ></mat-paginator>
    </div>
  </div>
</div>
